import { IkeFieldType } from '@ikegps/core-api';
import { FormModelField } from '../..';
import { getOtherAssignedSubformFieldIds } from '../form.subform.field.util';

export function isValidLeadLengthField(field: FormModelField): boolean {
	const excludeId = field.parent?.stateValue.anchorTypeState?.leadLengthFieldId;
	const otherIds = getOtherAssignedSubformFieldIds(field, excludeId);
	return field.type === IkeFieldType.VECTOR || (field.type === IkeFieldType.ANCHOR && !otherIds.includes(field.id));
}
